<template>
  <v-container fluid class="purchasereceipt-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindPurchaseReceipt=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn to="/purchaseorder/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Purchases
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              loading-text="Loading... Please wait"
              class="purchasereceipts-table"
              sort-by="purchasereceiptnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="purchasereceipts"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Purchase Recepit?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_receipt.purchasereceiptnum }} 
                      {{ delete_receipt.purchasereceiptname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_receipt)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.transactions="{ item }">
                <p class="two-line">Qty: {{ item.transactions.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.receiveQty),0).toFixed(0) }}</p>
              </template>
              <template v-slot:item.purchasereceiptimage="{ item }">
                    <v-img
                    v-if="item.purchasereceiptimage" 
                    v-bind:src="item.purchasereceiptimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.purchasereceiptnum="{ item }">
                
                <p class="two-line">{{ item.purchasereceipttype  }}</p>
                <p class="two-line">{{ item.purchasereceiptnum  }}</p>
                <p v-if="item.purchasereceiptdate!=undefined" class="two-line">{{ new Date(item.purchasereceiptdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.purchasereceiptname="{ item }">
                <p class="two-line">{{ item.purchasereceiptname }}</p>
                <p class="two-line" v-if="item.locationid!=undefined">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
              </template>
              <template v-slot:item.purchasereceiptstatus="{ item }">
                <v-chip
                  v-if="item.purchasereceiptstatus!=undefined"
                  :color="
                  item.purchasereceiptstatus=='Completed' ? 'successConst white--text' : 
                  item.purchasereceiptstatus=='Partial' ? 'warning white--text' : 
                  item.purchasereceiptstatus=='New' ? 'primaryConst white--text' : 
                  'secondaryConst white--text'" 
                  small
                >
                  {{ item.purchasereceiptstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <!-- <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.purchasereceiptstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindPurchaseReceipt"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Purchase Receipts</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Receipt Num"
                    v-model="find_query.purchasereceiptnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Receipt Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPurchaseReceipt = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetPurchaseReceipts"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPurchaseReceipts"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PurchaseReceiptList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindPurchaseReceipt: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_receipt: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'purchasereceiptimage', sortable: false, width: '8%' },
        { text: 'Receipt', value: 'purchasereceiptnum', sortable: false },
        { text: 'Name', value: 'purchasereceiptname' },
        { text: 'Received', value: 'transactions' },
        { text: 'Status', value: 'purchasereceiptstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      data_receipts: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('PurchaseReceipt', ['purchasereceipts', 'isReceiving', 'isDeleting','purchasereceiptsMessage']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('PurchaseReceipt', ["getPurchaseReceiptsRequest", "findPurchaseReceiptsRequest", "deletePurchaseReceiptRequest","updatePurchaseReceiptRequest","createPurchaseReceiptRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.purchasereceiptstatus=='Completed')!=null) return false;
      return true;
    },
    editItem(item) {
      this.$router.push({ name: 'PurchaseReceiptEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'PurchaseReceiptPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'PurchaseReceiptView', params: item });
    },
    async findPurchaseReceipts(){
      this.isFindPurchaseReceipt = false;
      if( Object.keys(this.find_query).length==0){
        await this.getPurchaseReceiptsRequest();
        this.data_receipts = Object.assign([], this.purchasereceipts);
      }
      else{
        let result = await this.findPurchaseReceiptsRequest(this.find_query);
        this.data_receipts = Object.assign([], result);
      }
    },
    async resetPurchaseReceipts(){
      this.find_query = {};
    },
    async deleteItem(item) {
      await this.deletePurchaseReceiptRequest({_id: item._id});
      this.data_receipts = this.purchasereceipts;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_receipt = {
        _id: item._id,
        purchasereceiptnum: item.purchasereceiptnum,
        purchasereceiptname: item.purchasereceiptname,
      }
    },
  },
  async created () {
    if(this.purchasereceipts.length==0) await this.getPurchaseReceiptsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
